import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/app/App";
import { appliquerMarque } from "@/shared/marque";

// Avant le rendu, pas apres : le titre de l'onglet et la couleur de la barre du
// navigateur viennent de `public/index.html`, servi a l'identique aux quatre adresses.
// Les reposer ici est le seul moment ou ils peuvent etre justes des le premier coup
// d'oeil, sans battement visible.
appliquerMarque();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
